var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRefresh = function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "inherit",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.932 4.825a15.68 15.68 0 0 1 13.246 2.423l-1.743 1.743a1.429 1.429 0 0 0 1.011 2.437h6.552A1.43 1.43 0 0 0 36.426 10V3.448a1.429 1.429 0 0 0-2.44-1.009l-1.748 1.749A19.997 19.997 0 0 0 .34 23.677a2.145 2.145 0 0 0 4.214-.792 15.71 15.71 0 0 1 11.377-18.06m23.723 11.497a2.144 2.144 0 0 0-4.214.792A15.712 15.712 0 0 1 10.818 32.75l1.743-1.743a1.43 1.43 0 0 0-1.015-2.437H4.998a1.43 1.43 0 0 0-1.429 1.428v6.552a1.428 1.428 0 0 0 2.44 1.008l1.749-1.748a19.997 19.997 0 0 0 31.897-19.486z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M22.298 11.502c-.566-2.474-4.1-2.46-4.643.023l-.023.102-.046.203a7.645 7.645 0 0 1-6.151 5.869c-2.58.448-2.58 4.154 0 4.6a7.645 7.645 0 0 1 6.16 5.9l.06.277c.543 2.48 4.077 2.497 4.643.02l.071-.323a7.69 7.69 0 0 1 6.183-5.868c2.586-.449 2.586-4.163 0-4.612a7.7 7.7 0 0 1-6.171-5.82l-.057-.245-.029-.126z",
    clipRule: "evenodd"
  })));
};
export default SvgRefresh;